export default __webpack_public_path__ + "static/media/GFGCs.0e70c8a7.png";